<template>
  <div>
    <vs-popup class="edit-user-popup" title="" :active.sync="editUserModalActive">
      <div class="vx-row flex-wrap title-bar">
        <h3>Edit User Details</h3>
      </div>

      <hr>

      <div class="vx-row flex-wrap justify-start px-5">
        <div class="vx-col sm:w-1/4 w-1/4 mb-2">
          <h5 class="mt-5">User Details</h5>
        </div>
      </div>

      <div class="vx-row flex-wrap justify-start px-5 mt-3">
        <div class="vx-col md:w-1/2 w-1/2 mb-2">
          <label class="vs-input--label inline-flex pb-2">Name</label>
          <vs-input
          class="w-full"
          name="Name"
          v-model="userDetails.name"
          disabled/>
        </div>

        <div class="vx-col md:w-1/2 w-1/2 mb-2">
          <label class="vs-input--label inline-flex pb-2">Email</label>
          <vs-input
          class="w-full"
          name="Email"
          v-model="userDetails.email"
          disabled/>
        </div>

        <div class="vx-col md:w-1/4 w-1/4 mb-2">
          <label class="vs-input--label inline-flex pb-2">User Role *</label>          
          <v-select
          name="User Role"
          class="custom-vselect"
          v-model="userDetails.role"
          :options="fetchRoles"
          append-to-body
          v-validate="{ required: !userDetails['role'] }"
          data-vv-validate-on="blur"
          :clearable="false"
          :disabled="false">
          </v-select>
          <span v-if="errors.has(`User Role`)" class="select-required-error--span span-text-validation"> Required field </span>
        </div>

        <div class="vx-col md:w-3/4 w-3/4 mb-12">
          <label class="vs-input--label inline-flex pb-2">Modules/Permission</label>
          <treeselect
          v-if="userDetails.id"
          name="User Role Permissions"
          class="w-full"
          :multiple="true"
          :options="modulesForRole"
          :sort-value-by="sortValueBy"
          :clearable="true"
          :default-expand-level="1"
          placeholder=""
          v-model="userDetails.modulePermissions" 
          :disabled="true">

          <div v-if="node.raw.permission_name" slot="value-label" slot-scope="{ node }"> {{ node.raw.permission_name.split('.')[0].split('_').join(' ') | toTitleCase }} : {{ node.raw.label }}</div>
          <div v-else slot="value-label" slot-scope="{ node }"> {{ node.raw.label }} : All Permissions</div>

          </treeselect>
        </div>
      </div>

      <hr class="mt-12">

      <div class="vx-row flex justify-end">
        <div class="vx-col mt-8 mb-3">
          <vs-button name="submit" id="button-with-loading" color="primary" type="filled" class="custom-btn ml-auto mb-4" @click="submit()" icon-after>Save</vs-button>
        </div>
      </div>
    </vs-popup>

    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
			<div class="con-content" slot="content">
        <p v-if="customPromptMessage" class="text-center">{{ customPromptMessage }}</p>
				<p v-else-if="customPromptError">{{ customPromptError }}</p>
      </div>
    </custom-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Treeselect from '@riophae/vue-treeselect';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
  name: 'EditUser',
  components: {
    'v-select': vSelect,
    Treeselect,
    CustomPrompt
  },
  data() {
    return {
      editUserModalActive: false,
      userDetails: {
        id: null,
        name: null,
        email: null,
        role: null,
        modulePermissions: []
      },
      modulesForRole: [],
      sortValueBy: 'ORDER_SELECTED',
       // Custom Dialog props
      customPrompt: {
        activePrompt: false,
        title: '',
        buttonText: '',
        type: '',
        color: '',
        classList: '',
        accept: null
      },
      customPromptMessage: null,
      customPromptError: null
    }
  },
  methods: {
    submit() {
      this.$validator.validate().then(async (valid) => { 
        if(valid) {
          let payload  = { role_id: [this.userDetails['role'].value] };
    
          this.$axiosSecure.post(`/users/${this.userDetails['id']}`, payload)
          .then((response) => {
            // this.customPromptMessage = response.data.message;
            this.customPromptMessage = 'User role updated successfully!';
            if(response.data.type == 'Success') {
              this.isAccessCodeSent = true;
    
              this.customPrompt['activePrompt'] = true;
              this.customPrompt['title'] = 'Success!';
              this.customPrompt['acceptText'] = 'Okay';
              this.customPrompt['color'] = 'primary'
            }
    
            this.editUserModalActive = false;
            this.$root.$emit('refreshUserList');
          })
          .catch((error) => {
            this.customPromptError = error.response.data.message;
    
            this.customPrompt['activePrompt'] = true;
            this.customPrompt['type'] = 'error';
            this.customPrompt['title'] = 'Error';
            this.customPrompt['acceptText'] = 'Okay';
            this.customPrompt['color'] = 'danger';
            this.customPrompt['classList'] = 'danger-prompt';
          })
        }
      })
    },
    fetchModulesForRole() {
      if(this.userDetails && this.userDetails.id && this.userDetails['role'] && this.userDetails['role'].value) {
        this.$axiosSecure.get(`/permissions/${this.userDetails['role'].value}`)
        .then((response) => {
          this.modulesForRole = response.data;
          this.userDetails['modulePermissions'] = [];
          this.modulesForRole.map(x => {
            let children = x.children.slice();
            let selectedChildren = children.filter(y => y.isSelected);
            
            this.userDetails['modulePermissions'].push(...selectedChildren.map(z => z.id));
          })
        })
        .catch((error) => {
          // Error notification
          this.$vs.notify({
            color: 'danger',
            title: 'Something went wrong',
            text: 'Please contact the server admin',
          });
        })
      } else {
        this.modulesForRole = [];
      }
    },
  },
  mounted() {
    this.$root.$on('openEditUserModal', (rowData) => {
      this.userDetails['id'] = rowData.data.id;
      this.userDetails['name'] = rowData.data.name;
      this.userDetails['email'] = rowData.data.email;
      if(rowData.data.role && rowData.data.role[0]) {
        this.userDetails['role'] = {
          label: rowData.data.role[0].name,
          value: rowData.data.role[0].id
        }
      }
      this.fetchModulesForRole();
      this.editUserModalActive = true;
    })
  },
  computed: {
    fetchUsers() {
      return this.$store.getters.getUsers;
    },
    fetchRoles() {
      return this.$store.getters.getRoles;
    },
  },
  watch: {
    fetchUsers() {
      return this.$store.getters.getUsers;
    },
    fetchRoles() {
      return this.$store.getters.getRoles;
    },
    'userDetails.role': {
      deep: true,
      handler() {
        this.fetchModulesForRole();
      }
    },
    editUserModalActive(val) {
      if(!val) {
        this.userDetails = {
          id: null,
          name: null,
          email: null,
          role: null,
          modulePermissions: []
        };
        this.modulesForRole = [];
      }
    }
  },
  destroyed() {
    this.$root.$off('openEditUserModal');
  }
}
</script>